import React from 'react';
import { NavLink, Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { Divider, Header, Icon, Menu } from 'semantic-ui-react';

import { clienteApi, Resultados } from 'src/api';
import { ResumenDeCurso } from 'src/api/protocolo/horarios';
import { NombrePersonal } from 'src/componentes';
import { Contexto } from 'src/contexto';
import MensajeRestriccion, { Props as Restringidos } from './componentes/MensajeRestringidos';
import AsistenciaDelAlumno from './paginas/AsistenciaDelAlumno';
import AtencionesOrientacionPsicopedagogiaDeAlumno from './paginas/AtencionesOrientacionPsicopedagogia';
import CambiosDeCurso, { Props as CambiosDeCursoProps } from './paginas/CambiosDeCurso';
import InformacionGeneral from './paginas/InformacionGeneral';
import PasesDeAtrasoDeAlumno from './paginas/PasesDeAtraso';
import Puntajes, { Props as PuntajesProps } from './paginas/Puntajes';
import RecuperacionesAgendadas from './paginas/RecuperacionesDeAlumno';

type Props = RouteComponentProps<{ numeroDeMatricula: string }>;

type State = Readonly<{
    cargando: boolean;
    ficha?: Resultados<'fichaAlumno'>;
    horario?: Resultados<'detalleDelAlumno'>;
    cambios?: CambiosDeCursoProps['registrosDeCambios'];
    listaDeCursos?: Resultados<'listaDeCursos'>['cursos'];
    restriccion?: Restringidos;
    puntajes?: PuntajesProps['puntajes'];
    asistencia?: Resultados<'asistenciaDelAlumno'>;
    recuperaciones?: Resultados<'recuperacionesAgendadasDelAlumno'>;
    todosLosCursos?: Map<string, ResumenDeCurso>;
    cursosInscritos?: Map<string, ResumenDeCurso>;
    atencionesOrientacion?: Resultados<'atencionesOrientacionDeAlumno'>;
    atencionesPsicopedagogia?: Resultados<'atencionesPsicopedagogiaDeAlumno'>;

    eliminandoRecuperacion: boolean;
}>;

class FichaDeAlumno extends React.Component<Props, State> {
    public static readonly contextType = Contexto;
    public readonly context!: React.ContextType<typeof Contexto>;

    public state: State = {
        cargando: true,
        eliminandoRecuperacion: false,
    };

    private readonly numeroDeMatricula = Number(this.props.match.params.numeroDeMatricula);

    public componentDidMount() {
        this.obtenerDatos().catch();
    }

    public render() {
        const { ficha, horario, puntajes, asistencia, recuperaciones, cargando } = this.state;
        if (ficha === undefined) return <div>Cargando...</div>;

        const { match } = this.props;
        const rutaBase = match.url;

        const rutas = {
            informacion: rutaBase + '/info',
            cambios: rutaBase + '/cambios',
            puntajes: rutaBase + '/puntajes',
            pasesRecuperacion: rutaBase + '/pases-recuperacion',
            recuperaciones: rutaBase + '/recuperaciones',
            pasesAtraso: rutaBase + '/pases-atraso',
            asistencia: rutaBase + '/asistencia',
            atencionesOrientacionPsicopedagogia:
                rutaBase + '/atenciones-orientacion-psicopedagogia',
        };

        return (
            <div>
                <Menu tabular>
                    <Menu.Item as={NavLink} to={rutas.informacion} content='Información' />

                    {this.mostrarCambiosDeCurso() && (
                        <Menu.Item as={NavLink} to={rutas.cambios} content='Cambios de curso' />
                    )}

                    {<Menu.Item as={NavLink} to={rutas.puntajes} content='Puntajes' />}

                    {<Menu.Item as={NavLink} to={rutas.recuperaciones} content='Recuperaciones' />}

                    {<Menu.Item as={NavLink} to={rutas.pasesAtraso} content='Pases de atraso' />}

                    {<Menu.Item as={NavLink} to={rutas.asistencia} content='Asistencia' />}

                    {
                        <Menu.Item
                            as={NavLink}
                            to={rutas.atencionesOrientacionPsicopedagogia}
                            content='Orientación y psicopedagogía'
                        />
                    }

                    {cargando && (
                        <Menu.Item icon>
                            <Icon loading name='spinner' />
                        </Menu.Item>
                    )}
                </Menu>

                {this.state.restriccion && <MensajeRestriccion {...this.state.restriccion} />}

                <Header as='h1' textAlign='left'>
                    <NombrePersonal nombre={ficha.alumno.personales.nombre} />
                </Header>
                <Divider hidden />

                <Switch>
                    <Redirect exact from={rutaBase} to={rutas.informacion} />

                    <Route
                        path={rutas.informacion}
                        render={() => (
                            <InformacionGeneral
                                cargando={cargando}
                                ficha={ficha}
                                horario={horario}
                            />
                        )}
                    />

                    {this.mostrarCambiosDeCurso() && (
                        <Route
                            path={rutas.cambios}
                            render={() => (
                                <CambiosDeCurso
                                    cursosInscritos={horario!.cursos}
                                    cursos={this.state.listaDeCursos!}
                                    registrosDeCambios={this.state.cambios!}
                                    alPresionarCambiar={this.registrarCambioDeCurso}
                                />
                            )}
                        />
                    )}

                    <Route
                        path={rutas.puntajes}
                        render={() => (
                            <Puntajes
                                puntajes={puntajes}
                                plan={
                                    ficha.alumno.matricula.plan === 'anual' ? 'anual' : 'intensivo'
                                }
                            />
                        )}
                    />

                    <Route
                        path={rutas.recuperaciones}
                        render={() => (
                            <RecuperacionesAgendadas
                                recuperaciones={recuperaciones !== undefined ? recuperaciones : []}
                                todosLosCursos={this.state.todosLosCursos}
                                eliminandoRecuperacion={this.state.eliminandoRecuperacion}
                                alCerrarModalRecuperacion={() =>
                                    this.setState({ eliminandoRecuperacion: false })
                                }
                                alEliminar={(idRecuperacion, idAlumno) => {
                                    this.setState({ eliminandoRecuperacion: true });
                                    this.eliminarRecuperacion(idRecuperacion, idAlumno);
                                }}
                            />
                        )}
                    />

                    <Route
                        path={rutas.pasesAtraso}
                        render={() => (
                            <PasesDeAtrasoDeAlumno
                                pases={horario !== undefined ? horario.pasesDeAtraso : []}
                                todosLosCursos={this.state.todosLosCursos}
                            />
                        )}
                    />

                    <Route
                        path={rutas.asistencia}
                        render={() => (
                            <AsistenciaDelAlumno
                                asistencia={asistencia}
                                todosLosCursos={this.state.todosLosCursos}
                            />
                        )}
                    />

                    <Route
                        path={rutas.atencionesOrientacionPsicopedagogia}
                        render={() => (
                            <AtencionesOrientacionPsicopedagogiaDeAlumno
                                atencionesOrientacion={
                                    this.state.atencionesOrientacion !== undefined
                                        ? this.state.atencionesOrientacion
                                        : []
                                }
                                atencionesPsicopedagogia={
                                    this.state.atencionesPsicopedagogia !== undefined
                                        ? this.state.atencionesPsicopedagogia
                                        : []
                                }
                            />
                        )}
                    />
                </Switch>
            </div>
        );
    }

    private construirMapaDeTodosLosCursos() {
        const todosLosCursos =
            this.state.listaDeCursos !== undefined ? this.state.listaDeCursos : [];
        const mapaDeTodosLosCursos = new Map<string, ResumenDeCurso>();
        for (const curso of todosLosCursos) {
            mapaDeTodosLosCursos.set(curso.nombre, curso);
        }
        this.setState({ todosLosCursos: mapaDeTodosLosCursos });
    }

    private construirMapaDeCursosInscritosDelAlumno() {
        const cursosInscritosAlumno =
            this.state.horario !== undefined ? this.state.horario.cursos : [];

        const mapaDeCursosInscritos = new Map<string, ResumenDeCurso>();
        for (const curso of cursosInscritosAlumno) {
            mapaDeCursosInscritos.set(curso.bloque, curso);
        }
        this.setState({ cursosInscritos: mapaDeCursosInscritos });
    }

    private mostrarCambiosDeCurso() {
        return (
            this.context.usuarioActual.tieneAlgunaDeEstasFunciones('encargado_docente') &&
            this.state.horario !== undefined &&
            this.state.listaDeCursos !== undefined &&
            this.state.cambios !== undefined
        );
    }

    private readonly obtenerDatos = async () => {
        this.setState({ cargando: true });

        try {
            const fichaAlumno = await this.obtenerFichaAlumno();

            const restricciones = await this.obtenerRestricciones();
            if (fichaAlumno.alumno.matricula.area !== 'ingles') {
                const detalleDelAlumno = await this.obtenerDetalleDelAlumno();
                if (detalleDelAlumno) {
                    await this.obtenerAsistencia(detalleDelAlumno.id);
                    await this.obtenerRecuperaciones(detalleDelAlumno.id);
                    if (!restricciones || !restricciones.puntaje) {
                        await this.obtenerPuntajes(detalleDelAlumno.id);
                    }
                }
            }
            await this.obtenerListaDeCursos();
            await this.obtenerAtencionesOrientacion();
            await this.obtenerAtencionesPsicopedagogia();
        } catch {
            // nada que hacer
        } finally {
            this.setState({ cargando: false }, () => {
                this.construirMapaDeTodosLosCursos();
                this.construirMapaDeCursosInscritosDelAlumno();
            });
        }
    };

    private async obtenerFichaAlumno() {
        try {
            const ficha = await clienteApi.ejecutar('fichaAlumno', {
                numeroDeMatricula: this.numeroDeMatricula,
            });
            this.setState({ ficha });
            return ficha;
        } catch (error) {
            this.context.mostrarModalError(error);
            throw error;
        }
    }

    private async obtenerDetalleDelAlumno() {
        try {
            const detalleAlumno = await clienteApi.ejecutar('detalleDelAlumno', {
                numeroDeMatricula: this.numeroDeMatricula,
            });
            this.setState({
                horario: detalleAlumno,
                cambios: agruparCambiosPorFecha(detalleAlumno),
            });
            return detalleAlumno;
        } catch (error) {
            this.manejarErrorAPI(error);
            return undefined;
        }
    }

    private readonly obtenerAtencionesOrientacion = async () => {
        return clienteApi
            .ejecutar('atencionesOrientacionDeAlumno', this.numeroDeMatricula)
            .then(resultados => {
                this.setState({
                    atencionesOrientacion: resultados,
                });
            })
            .catch(this.manejarErrorAPI);
    };

    private readonly obtenerAtencionesPsicopedagogia = async () => {
        return clienteApi
            .ejecutar('atencionesPsicopedagogiaDeAlumno', this.numeroDeMatricula)
            .then(resultados => {
                this.setState({
                    atencionesPsicopedagogia: resultados,
                });
            })
            .catch(this.manejarErrorAPI);
    };

    private readonly obtenerListaDeCursos = async () => {
        return clienteApi
            .ejecutar('listaDeCursos')
            .then(({ cursos }) => this.setState({ listaDeCursos: cursos }))
            .catch(this.manejarErrorAPI);
    };

    private readonly obtenerRestricciones = async () => {
        this.setState({ cargando: true });

        return clienteApi
            .ejecutar('alumnoEstaRestringido', this.numeroDeMatricula)
            .then(resultados => {
                this.setState({ restriccion: resultados });
                return resultados.restricciones;
            })
            .catch(this.manejarErrorAPI);
    };

    private readonly obtenerPuntajes = async (idAlumno: string) => {
        return clienteApi
            .ejecutar('obtenerPuntajeEnsayos', idAlumno)
            .then(puntajes => this.setState({ puntajes }))
            .catch(this.manejarErrorAPI);
    };

    private readonly obtenerAsistencia = async (idAlumno: string) => {
        return clienteApi
            .ejecutar('asistenciaDelAlumno', idAlumno)
            .then(asistencia => {
                this.setState({ asistencia });
            })
            .catch(this.manejarErrorAPI);
    };

    private readonly obtenerRecuperaciones = async (idAlumno: string) => {
        return clienteApi
            .ejecutar('recuperacionesAgendadasDelAlumno', idAlumno)
            .then(recuperaciones => {
                const recuperacionesOrdenadas = recuperaciones.sort(
                    (recuperacionA, recuperacionB) =>
                        recuperacionA.ingresadoEl.localeCompare(recuperacionB.ingresadoEl, 'es'),
                );
                this.setState({ recuperaciones: recuperacionesOrdenadas });
            })
            .catch(this.manejarErrorAPI);
    };

    private readonly eliminarRecuperacion = (idRecuperacion: string, idAlumno: string) => {
        if (!this.state.eliminandoRecuperacion) return;

        clienteApi
            .ejecutar('eliminarRecuperacionAgendada', { idRegistro: idRecuperacion })
            .then(() => this.obtenerRecuperaciones(idAlumno))
            .then(() => this.setState({ eliminandoRecuperacion: false }))
            .catch(this.context.mostrarModalError);
    };

    private readonly manejarErrorAPI = (error: Error & { tipo?: string }) => {
        // En general un objeto no existente no representa un error, sino solo
        // una parte del alumno que aún no ha sido completada. Simplemente no
        // mostrar esa parte debería ser suficiente, sin desplegar el modal.
        if (error.tipo === 'NO_ENCONTRADO') return;
        this.context.mostrarModalError(error);
    };

    private readonly registrarCambioDeCurso: CambiosDeCursoProps['alPresionarCambiar'] = async (
        cambios,
        motivo,
    ) => {
        for (const cambio of cambios) {
            try {
                await clienteApi.ejecutar('cambiarAlumnoDeCurso', {
                    numeroDeMatricula: this.state.ficha!.alumno.matricula.numeroDeContrato,
                    idCursoDeOrigen: cambio.origen,
                    idCursoDeDestino: cambio.destino,
                    motivo,
                });
            } catch (error) {
                this.context.mostrarModalError(error);
            }
        }

        this.obtenerDatos().catch();
    };
}

function agruparCambiosPorFecha(resultados: Resultados<'detalleDelAlumno'>) {
    const mapa = new Map<string, Array<{ origen: string; destino: string }>>();
    for (const registro of resultados.cambios) {
        const soloFecha = registro.registradoEl.slice(0, 10);
        const { cursoDeOrigen: origen, cursoDeDestino: destino } = registro;

        const cambios = mapa.get(soloFecha) || [];
        mapa.set(soloFecha, cambios.concat({ origen, destino }));
    }
    return Array.from(mapa, ([fecha, cambios]) => ({ fecha, cambios })).sort((a, b) => {
        // ordena a la inversa
        if (a.fecha < b.fecha) return 1;
        if (a.fecha > b.fecha) return -1;
        return 0;
    });
}

export default FichaDeAlumno;



// WEBPACK FOOTER //
// ./src/modulos/Alumnos/paginas/FichaDeAlumno/index.tsx